module.exports = __webpack_public_path__ + "img/center-header.64ee2658.png";